import { Chip } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CustomChip = styled(Chip)(() => ({
  display: "flex",
  gap: "16px",
  width: "fit-content",
  "& .MuiChip-deleteIcon": {
    color: "#1D3E70",
    "&:hover": {
      color: "#264a83",
    },
  },
}));
